// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"482":"e5dd8d21","488":"3492d691","558":"e761c0cd","573":"68ea6ae9"}[chunkId] + ".chunk.js";
};